import React from 'react'
import { Route, IndexRoute } from 'react-router'

//Authentication routes
import Login from '../components/authentication/Login'
import Signup from '../components/authentication/Signup'
import SignupChooseUserType from '../components/authentication/SignupChooseUserType'
import StudentSignup from '../components/student/StudentSignup'
import TeacherSignup from '../components/teacher/TeacherSignup'
import SchoolSignup from '../components/school/SchoolSignup'
import AppSignup from '../components/app/AppSignup'

//Authentication higher order components
import RedirectIfAuthenticated from '../components/HOCs/RedirectIfAuthenticated'

// misc. account actions
import ResetPasswordContainer from '../components/authentication/ResetPasswordContainer'
import ResetPasswordByEmail from '../components/authentication/ResetPasswordByEmail'
import ResetPasswordBySms from '../components/authentication/ResetPasswordBySms'
import ConfirmRestPass from '../components/authentication/ConfirmRestPass'
import SignupSuccess from '../components/authentication/SignupSuccess'
import ConfirmResetPassBySms from '../components/authentication/ConfirmResetPassBySms'
import RestPassSuccess from '../components/authentication/RestPassSuccess'

export const signupRoute = (
  <Route path="signup" component={RedirectIfAuthenticated(Signup)}>
    <IndexRoute component={SignupChooseUserType} />
    <Route path="student" component={StudentSignup} />
    <Route path="teacher" component={TeacherSignup} />
    <Route path="school" component={SchoolSignup} />
    <Route path="app" component={AppSignup} />
    <Route path="success" component={SignupSuccess} />
    <Route path="reset-password" component={ResetPasswordContainer} />
    <Route path="reset-password/by-email" component={ResetPasswordByEmail} />
    <Route path="reset-password/by-sms" component={ResetPasswordBySms} />
    <Route path="reset-password/by-sms/confirm-reset" component={ConfirmResetPassBySms} />
    <Route path="reset-password/by-sms/success" component={RestPassSuccess} />
  </Route>
)

export const loginRoute = (
  <Route path="login" component={RedirectIfAuthenticated(Login)} />
)

export const activateRoute = (
  <Route
    path="activate/:uid/:token"
    component={RedirectIfAuthenticated(ConfirmRestPass)}
  />
)



// WEBPACK FOOTER //
// ./src/routes/authRoutes.js